import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import ImageIcon from '@material-ui/icons/Image';
import { createTmpUploadedImgs } from '../../../handler/ChatAIHandler';
import { validateUploadImages, VALID_IMAGE_ACCEPT } from '../handler/UploadImageHandler';

const UploadImage = forwardRef(function UploadImage({
    corporationDetail,
    projectInuseDetail,
    chatThreadId,
    uploadImgs = [],
    uploadFiles = [],
    setUploadImgs,
    setIsUploading,
    showButton = true
}, ref) {
    const fileInputRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();

    useImperativeHandle(ref, () => ({
        triggerClick: () => {
            fileInputRef.current?.click();
        }
    }));

    const handleSelectImages = (event) => {
        const selectedImgs = Array.from(event.target.files);
        if (!selectedImgs || selectedImgs.length === 0) {
            event.target.value = '';
            return;
        }

        const isValidImgs = validateUploadImages(selectedImgs, uploadImgs, uploadFiles, enqueueSnackbar);
        if (!isValidImgs) {
            event.target.value = '';
            return;
        }

        const imgs = selectedImgs.map(file => ({
            id: `tmp_attach_${uuidv4()}`,
            localUrl: URL.createObjectURL(file),
            fileData: file
        }));
        setUploadImgs(prev => [...prev, ...imgs]);

        createTmpUploadedImgs(
            corporationDetail.id,
            projectInuseDetail.id,
            chatThreadId,
            imgs,
            setUploadImgs,
            setIsUploading
        );

        event.target.value = ''; // reset after selected
    };

    return (
        <div>
            {showButton && (
                <button
                    className="btn-reset-default ai-chat-input-btn"
                    onClick={() => fileInputRef.current?.click()}
                >
                    <ImageIcon onDragStart={e => { e.preventDefault(); }} />
                </button>
            )}
            <input
                style={{ display: 'none' }}
                draggable="false"
                ref={fileInputRef}
                type="file"
                multiple
                accept={VALID_IMAGE_ACCEPT}
                onChange={handleSelectImages}
            />
        </div>
    );
});

UploadImage.propTypes = {
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    chatThreadId: PropTypes.string,
    uploadImgs: PropTypes.array,
    uploadFiles: PropTypes.array,
    setUploadImgs: PropTypes.func,
    setIsUploading: PropTypes.func,
    getInputProps: PropTypes.func,
    showButton: PropTypes.bool
};

export default UploadImage;
